module.exports = __webpack_public_path__ + "static/img/close.bb40a267.png";